import { ItList } from 'types/graphql'

export type EditorNavItemName = 'basicInfoTab' | 'contentTab' | 'pricingTab'
export const MAX_DESCRIPTION_LENGTH = 2000
export const DESCRIPTION_WARNING_AFTER = 1500
export const MAX_PRICE = 99999

export type EditorNavItem = {
  label: string
  name: EditorNavItemName
  fields: (keyof ItList)[]
}

export type ItListBasicInfoFormData = Pick<
  ItList,
  | 'description'
  | 'hasVoiceIntro'
  | 'name'
  | 'notes'
  | 'socialProofUrl'
  | 'voiceIntroUrl'
  | 'coverUrl'
>

export type ItListPricingFormData = Pick<
  ItList,
  'price' | 'unlockWithEmail' | 'unlisted' | 'showDisclaimer' | 'disclaimer'
>

export type EditorStatus = 'ready' | 'saving'
